import { Alert } from '@mui/material';
import type { MediaDto } from '@/types/dtos/media/media.dto';
import { useTranslations } from '@/i18n/use-translations';

function latestAssetNeedsReupload(media: MediaDto): boolean {
  const latest = [...(media.assets ?? [])].sort((a, b) => b.version - a.version)[0];
  return latest?.uploadStatus === 'failed';
}

/** Asks for a new file when the latest upload was abandoned. Hidden during a live attempt. */
export function MediaIncompleteUploadNotice({ media, hidden }: { media: MediaDto; hidden?: boolean }) {
  const t = useTranslations();
  if (hidden || (!media.incompleteUpload && !latestAssetNeedsReupload(media))) {
    return null;
  }

  return (
    <Alert severity="warning" variant="outlined" sx={{ my: 1 }}>
      {t('media.uploadStatus.didNotFinish')}
    </Alert>
  );
}
